<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Select {{fieldLabel}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Close modal">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <!-- Search Bar -->
  <ion-toolbar>
    <ion-searchbar
      [(ngModel)]="searchTerm"
      (ionInput)="filterStaff()"
      placeholder="Search by name or email..."
      debounce="300"
      animated="true"
      aria-label="Search staff">
    </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- Selected Section -->
  <div class="section-container" *ngIf="selectedCount > 0">
    <div class="section-header selected-header">
      <div class="header-left">
        <ion-icon name="checkmark-circle" class="section-icon"></ion-icon>
        <h3>Selected</h3>
      </div>
      <ion-badge color="primary" class="count-badge">{{selectedCount}}</ion-badge>
    </div>

    <ion-list class="staff-list selected-list">
      <ion-item
        *ngFor="let staff of getSelectedStaff()"
        button
        detail="false"
        (click)="toggleStaff(staff)"
        class="staff-item selected-item"
        [attr.aria-label]="'Deselect ' + getStaffFullName(staff)">

        <div class="staff-avatar" slot="start">
          {{getStaffInitials(staff)}}
        </div>

        <ion-label class="staff-label">
          <h2 class="staff-name" [innerHTML]="highlightMatch(getStaffFullName(staff))"></h2>
          <p class="staff-email" *ngIf="staff.email" [innerHTML]="highlightMatch(staff.email)"></p>
        </ion-label>

        <ion-icon
          name="checkmark-circle"
          slot="end"
          class="selected-icon"
          color="primary">
        </ion-icon>
      </ion-item>
    </ion-list>
  </div>

  <!-- Available Section -->
  <div class="section-container" *ngIf="hasFilteredResults">
    <div class="section-header available-header">
      <div class="header-left">
        <ion-icon name="people-outline" class="section-icon"></ion-icon>
        <h3>Available</h3>
      </div>
      <ion-badge color="medium" class="count-badge">{{availableCount}}</ion-badge>
    </div>

    <ion-list class="staff-list available-list">
      <ion-item
        *ngFor="let staff of getAvailableStaff()"
        button
        detail="false"
        (click)="toggleStaff(staff)"
        class="staff-item available-item"
        [attr.aria-label]="'Select ' + getStaffFullName(staff)">

        <div class="staff-avatar" slot="start">
          {{getStaffInitials(staff)}}
        </div>

        <ion-label class="staff-label">
          <h2 class="staff-name" [innerHTML]="highlightMatch(getStaffFullName(staff))"></h2>
          <p class="staff-email" *ngIf="staff.email" [innerHTML]="highlightMatch(staff.email)"></p>
        </ion-label>

        <ion-icon
          name="ellipse-outline"
          slot="end"
          class="unselected-icon"
          color="medium">
        </ion-icon>
      </ion-item>
    </ion-list>
  </div>

  <!-- No Results State -->
  <div class="no-results" *ngIf="hasNoResults">
    <ion-icon name="search-outline" class="no-results-icon"></ion-icon>
    <h3>No staff found</h3>
    <p>Try adjusting your search terms</p>
  </div>

  <!-- Empty State (No Staff at all) -->
  <div class="empty-state" *ngIf="allStaff.length === 0">
    <ion-icon name="people-outline" class="empty-icon"></ion-icon>
    <h3>No staff available</h3>
    <p>There are no staff members to select</p>
  </div>

</ion-content>

<!-- Footer with Actions -->
<ion-footer>
  <ion-toolbar>
    <div class="footer-actions">
      <ion-button
        fill="clear"
        color="danger"
        (click)="clearAll()"
        [disabled]="selectedCount === 0"
        aria-label="Clear all selections">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        Clear All
      </ion-button>

      <ion-button
        fill="clear"
        color="primary"
        (click)="selectAll()"
        [disabled]="availableCount === 0"
        aria-label="Select all available">
        <ion-icon slot="start" name="checkbox-outline"></ion-icon>
        Select All
      </ion-button>

      <ion-button
        fill="solid"
        color="primary"
        (click)="confirm()"
        class="confirm-button"
        aria-label="Confirm selection">
        <ion-icon slot="start" name="checkmark-circle"></ion-icon>
        Done ({{selectedCount}})
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
